import vSpinner from './Spinner';

export { vSpinner };



// WEBPACK FOOTER //
// ./src/baseComponents/components/Spinner/index.js